var map = {
	"./ar.json": 832,
	"./en.json": 1304,
	"./es.json": 5839,
	"./fr.json": 6491,
	"./id.json": 1910,
	"./ko.json": 5645,
	"./pt.json": 5755,
	"./ru.json": 1074,
	"./uz.json": 8084,
	"./vi.json": 1602,
	"./zh.json": 2377
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5035;